import { shopId } from "../config/const";
import {
  accessTokenHeader,
  callFetch,
  header,
  idTokenHeader,
  tokenHeader,
} from "./utils";

const EndPoint = {
  RefreshIdToken: () => `/linewebhook/customer/shop/${shopId}/oauth/refresh`,
  GetCreateCustomer: (lineId) =>
    `/linewebhook/customer/shop/${shopId}/oauth/${lineId}?options=idToken,hasEcid`,
  GetCarts: (lineId) => `/linewebhook/customer/shop/${shopId}/${lineId}/carts`,
  UpdateCart: (lineId) => `/linewebhook/cart/shop/${shopId}/${lineId}`,
  ReplaceCart: (lineId) => `/linewebhook/cart/shop/${shopId}/${lineId}`,
  UpdateCustomer: (lineId) => `/linewebhook/customer/shop/${shopId}/${lineId}`,
  SendPhoneVerify: (lineId) =>
    `/linewebhook/customer/shop/${shopId}/${lineId}/phone-verify`,
  VerifyPhone: (lineId) =>
    `/linewebhook/customer/shop/${shopId}/${lineId}/verify-phone`,
  BindEcid: (lineId) =>
    `/linewebhook/customer/shop/${shopId}/oauth/${lineId}/ecid`,
};

// Customer
export function getCreateCustomer(lineId, accessToken) {
  const uri = EndPoint.GetCreateCustomer(lineId);
  let settings = {
    method: "POST",
    headers: { ...header },
    body: JSON.stringify({ accessToken }),
  };

  return callFetch(uri, settings);
}

export function refreshIdToken(token) {
  const uri = EndPoint.RefreshIdToken();
  let settings = {
    method: "POST",
    headers: header,
    body: JSON.stringify({ refreshToken: token }),
  };

  return callFetch(uri, settings);
}

export function updateCustomer(lineId, idToken, data = {}) {
  const uri = EndPoint.UpdateCustomer(lineId);
  let settings = {
    method: "PATCH",
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
    body: JSON.stringify(data),
  };

  return callFetch(uri, settings);
}

export function getCarts(lineId, accessToken, idToken) {
  const uri = EndPoint.GetCarts(lineId);
  let settings = {
    method: "GET",
    headers: {
      ...accessTokenHeader(accessToken),
      ...idTokenHeader(idToken),
      ...tokenHeader,
    },
  };

  return callFetch(uri, settings);
}

export function updateCart(lineId, idToken, carts = {}) {
  const uri = EndPoint.UpdateCart(lineId);
  let settings = {
    method: "PATCH",
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
    body: JSON.stringify(carts),
  };

  return callFetch(uri, settings);
}

export function replaceCart(lineId, idToken, item = []) {
  const uri = EndPoint.ReplaceCart(lineId);
  let settings = {
    method: "PUT",
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
    body: JSON.stringify(item),
  };

  return callFetch(uri, settings);
}

export function sendPhoneVerify(lineId, idToken, phone) {
  const uri = EndPoint.SendPhoneVerify(lineId);
  let settings = {
    method: "POST",
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
    body: JSON.stringify({
      phone,
      options: {
        length: 4,
        hasCharacter: false,
        verifyCodeMessage:
          "您好, 歡迎您參加OCTO 10週年紀念展。\n您的行動電話 OTP 驗證碼為「{{code}}」，請立即前往預約頁面輸入，完成驗證作業。",
      },
    }),
  };

  return callFetch(uri, settings);
}

export function verifyPhone(lineId, idToken, phone, code) {
  const uri = EndPoint.VerifyPhone(lineId);
  let settings = {
    method: "POST",
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
    body: JSON.stringify({ phone, code }),
  };

  return callFetch(uri, settings);
}

export function bindEcid(lineId, idToken, accessToken, ecid) {
  const uri = EndPoint.BindEcid(lineId);
  let settings = {
    method: "POST",
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
    body: JSON.stringify({ accessToken, ecid }),
  };

  return callFetch(uri, settings);
}
